import styled from 'styled-components';

export const $InlineField = styled.div`
  margin-bottom: 0.5rem;
  min-width: 0;
  line-height: 1.35;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const $InlineFieldLabel = styled.span`
  color: ${({ theme }) => theme.newUI?.defaultColors?.secondaryText ?? '#64748b'};
  font-size: ${({ theme }) => theme.fonts.size.ultraSmall};
  font-weight: ${({ theme }) => theme.fonts.weight.mediumFont ?? 500};

  &::after {
    content: ':';
    margin-right: 0.35rem;
  }
`;

export const $InlineFieldValue = styled.span`
  color: ${({ theme }) => theme.newUI?.defaultColors?.text ?? theme.colors.mainTextColor};
  font-size: ${({ theme }) => theme.fonts.size.small};
  font-weight: ${({ theme }) => theme.fonts.weight.normal};
`;

export const $ShowAllButtonWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0.75rem;
  padding-top: 0.5rem;
  border-top: 1px solid ${({ theme }) => theme.newUI?.defaultColors?.border ?? '#e2e8f0'};
`;

export const $ShowAllButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  margin: 0;
  padding: 0.15rem 0.35rem;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.newUI?.defaultColors?.secondaryText ?? '#64748b'};
  font-size: ${({ theme }) => theme.fonts.size.ultraSmall};
  font-weight: ${({ theme }) => theme.fonts.weight.mediumFont ?? 500};
  line-height: 1.2;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    color: ${({ theme }) => theme.newUI?.defaultColors?.primary ?? theme.colors.primary};
    outline: none;
  }

  svg {
    flex-shrink: 0;
  }
`;
